import React from 'react'
import { MdSettings } from "react-icons/md";
import './IconStyles.css';

export const MetadataIcon = (props) => (
   <div style={{minWidth: "1.75em"}}>
    <MdSettings size={props.size ? props.size : "1.25em"}
                       color={props.color ? props.color : undefined}
    />
   </div>
)
